module.exports = __webpack_public_path__ + "static/favicon-f4f9b8838f578a94af77f9dab81b4706.png";